module.exports = __webpack_public_path__ + "img/chrome.da264f0e.png";